export function isWeekday(d: Date): boolean {
	const day = d.getDay();
	return day !== 0 && day !== 6;
}

export function countWeekdays(from: Date, to: Date): number {
	if (from > to) return 0;
	let count = 0;
	const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
	const end = new Date(to.getFullYear(), to.getMonth(), to.getDate());
	while (d <= end) {
		if (isWeekday(d)) count++;
		d.setDate(d.getDate() + 1);
	}
	return count;
}

export function workdaysInYear(year: number): number {
	return countWeekdays(new Date(year, 0, 1), new Date(year, 11, 31));
}
